import { useEffect } from 'react'

import { useAppDispatch } from 'app/hooks'

import { setShowRiskDensitySync } from 'features/RiskManagement/Components/LocalFilter/localFilterSlice'

export const useToggleRiskDensity = () => {
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(setShowRiskDensitySync(true))

    return () => {
      dispatch(setShowRiskDensitySync(false))
    }
  }, [dispatch])
}
